import {UserOPEEnum} from "../UserOPEEnum";
import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";

class UserMetricGroupDTO {
  id!: number;
  name!: string;
}

class O {
  groups!: UserMetricGroupDTO[];

  constructor() {
    this.groups = [];
  }
}

/**
 * I Inner Class
 */
class I {
  // Omit for the authenticated user's own charts. A partition/system admin can pass the id of
  // another user of equal or lower role, within the partitions they are enabled on.
  userId?: number;
}

/**
 * Impersonation-aware counterpart of getUserMetricGroups, which stays self-only.
 */
export class GetAllUserMetricGroupsCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(UserOPEEnum.GetAllUserMetricGroups);
    this.i = new I();
    this.o = new O();
  }

}
